import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * CaseStudyCard Component
 * Displays a single case study card with image, title, description, and navigation
 * Clicking on the card or "Read More" navigates to the full case study page
 */
const CaseStudyCard = ({ id, image, title, description, onCardClick }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    if (onCardClick) {
      onCardClick(id);
    } else {
      // Default behavior: navigate to case study detail page
      navigate(`/case-study/${id}`);
    }
  };

  return (
    <div
      onClick={handleCardClick}
      className="bg-white border border-[rgba(0,0,0,0.1)] border-solid content-stretch flex flex-col items-start justify-center overflow-clip relative rounded-[16px] shadow-[0px_4px_8px_0px_rgba(0,0,0,0.02),0px_6px_12px_0px_rgba(0,0,0,0.03)] shrink-0 w-full max-w-[416px] cursor-pointer hover:shadow-[0px_8px_16px_0px_rgba(0,0,0,0.08)] transition-shadow duration-300"
    >
      {/* Image Section */}
      <div className="h-[240px] relative shrink-0 w-full overflow-hidden">
        <img
          alt={title}
          className="absolute inset-0 max-w-none object-cover pointer-events-none size-full hover:scale-105 transition-transform duration-300"
          src={image}
        />
      </div>

      {/* Card Body */}
      <div className="content-stretch flex flex-col font-['Satoshi_Variable:Medium',sans-serif] font-medium gap-[32px] items-start justify-center leading-[0] p-[24px] relative shrink-0 w-full">
        {/* Text Content */}
        <div className="content-stretch flex flex-col gap-[8px] items-start relative shrink-0 text-ellipsis w-full">
          {/* Title */}
          <div className="flex flex-col justify-center overflow-hidden relative shrink-0 text-[24px] text-black tracking-[-0.48px] w-full">
            <p className="leading-[1.45] overflow-hidden line-clamp-2">
              {title}
            </p>
          </div>

          {/* Description */}
          <div className="flex flex-col justify-center overflow-hidden relative shrink-0 text-[18px] text-[rgba(0,0,0,0.55)] tracking-[-0.09px] w-full">
            <p className="leading-[1.4] line-clamp-3">{description}</p>
          </div>
        </div>

        {/* Read More Link */}
        <div
          className="flex flex-col justify-center relative shrink-0 text-[18px] text-black tracking-[-0.09px] whitespace-nowrap font-semibold hover:text-[#2aa366] transition-colors duration-300"
          onClick={(e) => {
            e.stopPropagation();
            handleCardClick();
          }}
        >
          <p className="leading-[1.45]">Read More →</p>
        </div>
      </div>
    </div>
  );
};

export default CaseStudyCard;
